import React from "react";
import { ReactComponent as TryAgainIllustration } from "assets/images/try-again-illustration.svg";
import { Box, GhostIconButton, PrimaryButton, Text } from "components";
import useTrackPageAnalytics from "hooks/useTrackPageAnalytics";
import { useTranslation } from "react-i18next";
import { getTranslationsStyle } from "utils/arabisation.util";

/**
 * Full-page view displayed when a technical/OCR error occurs and the user is allowed to retry.
 * Clean layout: close icon, centered illustration, title, description, and "Try Again" button.
 */
const TryAgainContent = ({ onTryAgain, onClose }) => {
  const { sendAnalytics } = useTrackPageAnalytics();
  const { t, i18n } = useTranslation();

  return (
    <Box
      d="flex"
      direction="column"
      backgroundColor="backgroundTertiary"
      style={{
        height: "100dvh",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1000,
      }}
    >
      {/* Close icon - 24px (m) from top and right */}
      <Box d="flex" justifyContent="flex-end" pT="m" pH="m">
        <GhostIconButton
          name="clearclose"
          color="inherit"
          iconSize="l"
          onClick={onClose}
        />
      </Box>

      {/* Centered content */}
      <Box
        d="flex"
        direction="column"
        alignItems="center"
        justifyContent="center"
        flex="1"
        pH="l"
        gap="m"
      >
        <TryAgainIllustration />

        <Text
          fontSize="l"
          fontWeight="bold"
          textAlign="center"
          mT="s"
          style={getTranslationsStyle(i18n)}
        >
          {t("smart_gate.try_again_title")}
        </Text>

        <Text
          fontSize="m"
          textAlign="center"
          style={getTranslationsStyle(i18n)}
        >
          {t("smart_gate.try_again_description")}
        </Text>

        <Box mT="s">
          <PrimaryButton
            onClick={() => {
              sendAnalytics({
                key: "smart-gate-click-try-again",
                type: "event",
                name: "User clicked Try Again after technical error",
              });
              onTryAgain();
            }}
            w="220px"
          >
            <Text style={getTranslationsStyle(i18n)} fontSize="m">
              {t("smart_gate.try_again")}
            </Text>
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  );
};

export default TryAgainContent;
